// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["assets/app/css/app","assets/app/css/tailwind"], () => (__webpack_require__("./resources/js/app.js")))
__webpack_require__.O(undefined, ["assets/app/css/app","assets/app/css/tailwind"], () => (__webpack_require__("./resources/sass/app.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/app/css/app","assets/app/css/tailwind"], () => (__webpack_require__("./resources/css/tailwind.css")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
